var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricityFinishing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6925 3.75H11.4375V1.5C11.4375 1.1925 11.1825 0.9375 10.875 0.9375C10.5675 0.9375 10.3125 1.1925 10.3125 1.5V3.75H7.6875V1.5C7.6875 1.1925 7.4325 0.9375 7.125 0.9375C6.8175 0.9375 6.5625 1.1925 6.5625 1.5V3.75H6.3075C5.52 3.75 4.875 4.395 4.875 5.1825V9C4.875 10.65 6 12 7.875 12H8.4375V16.5C8.4375 16.8075 8.6925 17.0625 9 17.0625C9.3075 17.0625 9.5625 16.8075 9.5625 16.5V12H10.125C12 12 13.125 10.65 13.125 9V5.1825C13.125 4.395 12.48 3.75 11.6925 3.75Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityFinishing);
export default __webpack_public_path__ + "static/media/electricity-finishing.78552a2d35a763584b2d415bc1eb1de3.svg";
export { ForwardRef as ReactComponent };